import { getTranslation } from "../../assets/creator/translations";

export default function getTranslatedInnerSvg(svgContent, recType = null) {
    svgContent = svgContent.default || svgContent;
    svgContent = svgContent.toString();
    const { keySet, limits } = getNeededTranslationKeys(svgContent);
    const retObj = { __html: svgContent };
    keySet.forEach(replaceKeysWithTranslations(limits, retObj))
    limits.forEach(removeLimitsFromKeys(retObj));
    if (recType != null) {
      setRecommendedFlagsAndLabels(retObj, recType);
    }
      checkAndUpdateYearOnPreview(retObj);
      setCartDeliveryDateOnPreview(retObj);
      setArticleDateOnPreview(retObj);
    return retObj;
  }
  
  
  
  /**
   * After replacing keys with translations, the last thing is to remove all :LIMIT_charNumber texts from svg before render
   * @param {{__html: string }} retObj 
   */
  const removeLimitsFromKeys = (retObj) => value => {
    const stringValue = value.toString(10);
    retObj.__html = retObj.__html.replace(new RegExp(":LIMIT_0*?" + stringValue, 'g'), "");
  };
  
  
  /**
   * scans svg content for translatable content
   * translatable content is marker as follows
   * TRANSLATION_Name_Of_The_Key{Number of subkey}:LIMIT_charNumber
   * @param {string} svgContent 
   * @returns {{keySet: Set<string>, limits: Map<string, number>}}
   */
  function getNeededTranslationKeys(svgContent) {
    //main parsing regex: TRANSLATION_Name_Of_The_Key{Number of subkey}:LIMIT_charNumber
    const regex = /TRANSLATION_([a-zA-Z_]+(\{\d+\})?)(:LIMIT_(\d+))?/g;
    // declare match identifier 
    let match = null;
    //set of translation keys
    const keySet = new Set();
    //map of key-limit pairs
    const limits = new Map();
    while ((match = regex.exec(svgContent)) !== null) {
      keySet.add(match[1]);
      if (match[4]) { 
        //limit is optional, if found, add to the map
        limits.set(match[1], parseInt(match[4], 10));
      }
    }
    return { keySet, limits };
  }
  
  /**
   * 
   * @param {Map<string, number>} limits 
   * @param {{__html: string}} retObj 
   */
  const replaceKeysWithTranslations = (limits, retObj) => key => {
    const escapedKey = key.replace(/\{/g, "\\{");
    let translation = getTranslation(key);
    
    if (limits.has(key)) {//if svg has text length constraint
        const limit = limits.get(key);
        if(limit>0 && translation.length > limit) {//if there's a positive limit and the translation's length is bigger than said limit
          translation = translation.substr(0, limit-3).trimRight()+"...";//cut the translation and add '...' at the end
        }
    }
    retObj.__html = retObj.__html.replace(new RegExp("TRANSLATION_" + escapedKey, 'g'), translation);
  }

  const setWidthOfFlag = (text, settings = require('../../assets/settings').default) => {
    const fontFamily = settings.fontFamily;
    const canvas = document.createElement("canvas");
    const context = canvas.getContext("2d");
    context.font = `500 10px '${fontFamily}'`;
    return context.measureText(text).width + 21;
  }

  const setRecommendedFlagsAndLabels = (retObj, recType) => {
    let labelText = '';
    let flagColorClass = '';
    let flagText = '';
    let flagStyle = '';
    let text = "";
    switch(recType) {
      case 1:
        labelText = getTranslation('Prv_Rec_Promotion');
        flagColorClass = 'ribbonPromotion';
        text = getTranslation('Prv_Flag_Rec_Promotion');
        flagText = text;
        flagStyle = `width="${setWidthOfFlag(text)}"`;
        break;

      case 2:
        labelText = getTranslation('Prv_Rec_NewProduct');
        flagColorClass = 'ribbonNewProduct';
        text = getTranslation('Prv_Flag_Rec_NewProduct');
        flagText = text;
        flagStyle = `width="${setWidthOfFlag(text)}"`;
        break;

      case 3:
        labelText = getTranslation('Prv_Rec_MostViewed');
        flagStyle = 'display="none"';
        break;

      case 4:
        labelText = getTranslation('Prv_Rec_TopSellers');
        flagStyle = 'display="none"';
        break; 

      case 5:
        labelText = getTranslation('Prv_Rec_CrossSeling');
        flagStyle = 'display="none"';
        break; 

      case 6:
        labelText = getTranslation('Prv_Rec_ProductFromNewsletter');
        flagColorClass = 'ribbonPromotionalProduct';
        text = getTranslation('Prv_Flag_Rec_ProductFromNewsletter');
        flagText = text;
        flagStyle = `width="${setWidthOfFlag(text)}"`;
        break; 

      case 7:
        labelText = getTranslation('Prv_Rec_RecomendedProducts');
        flagColorClass = 'ribbonRecommendedProduct';
        text = getTranslation('Prv_Flag_Rec_RecomendedProducts');
        flagText = text;
        flagStyle = `width="${setWidthOfFlag(text)}"`;
        break; 

      case 8:
        labelText = getTranslation('Prv_Rec_ProductSale');
        flagColorClass = 'ribbonSale';
        text = getTranslation('Prv_Flag_Rec_ProductSale');
        flagText = text;
        flagStyle = `width="${setWidthOfFlag(text)}"`;
        break; 

      case 9:
        labelText = getTranslation('Prv_Rec_ProductExtraQuality');
        flagColorClass = 'ribbonGreatQuality';
        text = getTranslation('Prv_Flag_Rec_ProductExtraQuality');
        flagText = text;
        flagStyle = `width="${setWidthOfFlag(text)}"`;
        break; 

      case 10:
        labelText = getTranslation('Prv_Rec_ProductExtraPrice');
        flagColorClass = 'ribbonGreatPrice';
        text = getTranslation('Prv_Flag_Rec_ProductExtraPrice');
        flagText = text;
        flagStyle = `width="${setWidthOfFlag(text)}"`;
        break; 

      case 11:
        labelText = getTranslation('Prv_Rec_BestRated');
        flagColorClass = 'ribbonBestRated';
        text = getTranslation('Prv_Flag_Rec_BestRated');
        flagText = text;
        flagStyle = `width="${setWidthOfFlag(text)}"`;
        break; 

      case 12:
        labelText = getTranslation('Prv_Rec_ProductSellerRecommended');
        flagColorClass = 'ribbonVendorRecomendation';
        text = getTranslation('Prv_Flag_Rec_ProductSellerRecommended');
        flagText = text;
        flagStyle = `width="${setWidthOfFlag(text)}"`;
        break; 

      case 13:
        labelText = getTranslation('Prv_Rec_ProductAnnouncement');
        flagStyle = 'display="none"';
        break; 

      case 14:
        labelText = getTranslation('Prv_Rec_SuggestedProducts');
        flagStyle = 'display="none"';
        break; 

      case 15:
        labelText = getTranslation('Prv_Rec_Reward');
        flagColorClass = 'ribbonReward';
        text = getTranslation('Prv_Flag_Rec_Reward');
        flagText = text;
        flagStyle = `width="${setWidthOfFlag(text)}"`;
        break; 
      
      case 16:
      case 17:
      case 18:
      case 19:
      case 20:
        labelText = getTranslation('Prv_Rec_RecomendedProducts');
        flagStyle = 'display="none"';
        break; 

      default:
        labelText = getTranslation('Prv_Rec_RecomendedProducts');
        flagColorClass = 'ribbonRecommendedProduct';
        text = getTranslation('Prv_Rec_RecomendedProducts');
        flagText = text;
        flagStyle = `width="${setWidthOfFlag(text)}"`;
        break;
    }

    retObj.__html = retObj.__html.replace(/RECOMMENDEDTYPE_LABEL/g, labelText);
    retObj.__html = retObj.__html.replace(/RECOMMENDEDTYPE_FLAGTEXT/g, flagText);
    retObj.__html = retObj.__html.replace(/RECOMMENDEDTYPE_FLAGSTYLE/g, flagStyle);
    retObj.__html = retObj.__html.replace(/RECOMMENDEDTYPE_FLAGCOLOR/g, flagColorClass);
  }

  const checkAndUpdateYearOnPreview = (retObj) => {
    const currentYear = new Date().getFullYear();
    retObj.__html = retObj.__html.replace(/PREVIEW_YEAR/g, currentYear);
  }

  const setCartDeliveryDateOnPreview = (retObj) => {
    const deliveryDate = new Date();
    deliveryDate.setDate(deliveryDate.getDate() + 3);

    retObj.__html = retObj.__html.replace(/PREVIEW_DELIVERYDATE/g, formatDeliveryDate(deliveryDate));
  }

  const setArticleDateOnPreview = (retObj) => {
    const firstPostDate = new Date();
    firstPostDate.setDate(firstPostDate.getDate());

    const secondPostDate = new Date();
    secondPostDate.setDate(secondPostDate.getDate() - 3);

    const thirdPostDate = new Date();
    thirdPostDate.setDate(thirdPostDate.getDate() - 7);

    const fourthPostDate = new Date();
    fourthPostDate.setDate(fourthPostDate.getDate() - 10);

    retObj.__html = retObj.__html.replace(/PREVIEW_FIRSTPOSTDATE/g, formatDeliveryDate(firstPostDate));
    retObj.__html = retObj.__html.replace(/PREVIEW_SECONDPOSTDATE/g, formatDeliveryDate(secondPostDate));
    retObj.__html = retObj.__html.replace(/PREVIEW_THIRDPOSTDATE/g, formatDeliveryDate(thirdPostDate));
    retObj.__html = retObj.__html.replace(/PREVIEW_FOURTHPOSTDATE/g, formatDeliveryDate(fourthPostDate));

  }

  function formatDeliveryDate(date) {
    return [
      (date.getDate()).toString().padStart(2, '0'),
      (date.getMonth() + 1).toString().padStart(2, '0'),
      date.getFullYear()
    ].join('.');
  }